module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746b_banner_800x600.eb8f2e8b.png";